const formatter = new Intl.NumberFormat('en-IN', {
  style: 'currency',
  currency: 'INR',
  maximumFractionDigits: 0,
})

export function Money({ paise }: { paise: number }) {
  return <>{formatter.format(paise / 100)}</>
}
